// =====================================================
// ActivityTracker  (Admin Activity Dashboard)
// A render-less component that activates the app-wide activity tracker. Mounted
// once inside the Router in App.js. Renders nothing and adds no DOM — it exists
// only so the useActivityTracker hook can run in a Router context (it needs
// useLocation). Safe on public pages: the hook no-ops when not authenticated.
// =====================================================

import useActivityTracker from "../hooks/useActivityTracker";

export default function ActivityTracker() {
  useActivityTracker();
  return null;
}
